import React from 'react';

interface Props {
	children: string | React.ReactElement | React.ReactElement[];
	className?: string;
	style?: React.CSSProperties;
}

const NoEscape: React.FC<Props> = ({ className, children, style }) => {
	return (
		<div
			className={className}
			style={style}
			dangerouslySetInnerHTML={{ __html: children }}
		/>
	);
};

export default NoEscape;
